import React, { useState, useEffect } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { RiErrorWarningFill } from "react-icons/ri";
import ReactTooltip from "react-tooltip";
import { CSSTransition } from "react-transition-group";

const Info = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);
  return (
    <CSSTransition
      in={show}
      timeout={300}
      classNames="infoContainerAlert"
      unmountOnExit
    >
      <div className="infoContainer" style={{ marginTop: "25px" }}>
        <RiErrorWarningFill className="info-icon" />
        <ul>
          <li style={{ display: "flex", gap: "10px" }}>
            You are a Spectator of this contest
            <span>
              <FaInfoCircle
                size={16}
                data-tip="Spectator can see Leaderboard and winnings of the contest"
              />
              <ReactTooltip place="top" effect="float" />
            </span>
          </li>
          <li>You are not allowed to play this contest as you haven't paid</li>
        </ul>
      </div>
    </CSSTransition>
  );
};

export default Info;
